var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex } from '../Flex';
import { Link } from '../Link';
import { SrOnly } from '../SrOnly';
/*
 * :focus-within property not supported on ie11
 * If ie11 support is needed, we would probably need to go with state/focus delagation solution
 */
var OffScreenPanel = styled(SrOnly)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:focus-within {\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    clip: auto;\n    margin: 0;\n    overflow: unset;\n  }\n"], ["\n  &:focus-within {\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    clip: auto;\n    margin: 0;\n    overflow: unset;\n  }\n"])));
var propTypes = {
    className: PropTypes.string,
    skipLinks: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        targetId: PropTypes.string,
    })),
};
var SkipMenu = function (_a) {
    var className = _a.className, skipLinks = _a.skipLinks, props = __rest(_a, ["className", "skipLinks"]);
    if (!(skipLinks === null || skipLinks === void 0 ? void 0 : skipLinks.length))
        return null;
    return (React.createElement(OffScreenPanel, __assign({ "data-testid": 'skip-menu', as: Flex, className: className }, props), skipLinks === null || skipLinks === void 0 ? void 0 : skipLinks.map(function (_a) {
        var label = _a.label, targetId = _a.targetId, skipLink = __rest(_a, ["label", "targetId"]);
        return (React.createElement(Link, __assign({ key: "skipLink_".concat(targetId), href: "#".concat(targetId), p: 2 }, skipLink), label));
    })));
};
SkipMenu.displayName = 'SkipMenu';
SkipMenu.propTypes = propTypes;
export default SkipMenu;
var templateObject_1;
//# sourceMappingURL=SkipMenu.js.map